import React from 'react';
import { observer } from 'mobx-react-lite';
import { runInAction } from 'mobx';
import { IndicatorDto } from '../../../types/indicator';
import FroalaEditorComponent from 'react-froala-wysiwyg';
import useStore from '../../../store/storeContext';

interface Props {
    indicator: IndicatorDto;
}

function FroalaIndicatorDescription(props: Props) {
    const context = useStore();
    const { snackbar } = context;

    async function saveDescription(): Promise<void> {
        try {
            await context.indicator.saveIndicator(props.indicator);
        } catch (e) {
            snackbar.showError(e.data?.['TranslationKey']);
        }
    }

    function onModelChange(description: string): void {
        runInAction(() => (props.indicator.description = description !== '' ? description : null));
        void saveDescription();
    }

    return (
        <FroalaEditorComponent
            model={props.indicator.description}
            onModelChange={onModelChange}
            config={{ ...context.document.froalaFocusAreaConfig }}
        />
    );
}

export default observer(FroalaIndicatorDescription);
